import { createElement } from 'react';
import { ListFilter } from 'lucide-react';
import type { IconType } from 'react-icons';
import { TbCalendarTime, TbForms, TbId, TbSend } from 'react-icons/tb';

const QueryBuilderIcon: IconType = (props) => createElement(ListFilter, { ...props, size: '0.875rem' });

export type AlertFormSectionKey = 'identity' | 'templates' | 'query' | 'delivery' | 'schedule';

export interface AlertFormStep {
    icon: IconType;
    id: string;
    key: AlertFormSectionKey;
    label: string;
}

export const alertFormSteps: AlertFormStep[] = [
    { key: 'identity', id: 'alert-form-identity', icon: TbId, label: 'Alert Identity' },
    { key: 'templates', id: 'alert-form-templates', icon: TbForms, label: 'Templates' },
    { key: 'query', id: 'alert-form-query', icon: QueryBuilderIcon, label: 'Query Builder' },
    { key: 'delivery', id: 'alert-form-delivery', icon: TbSend, label: 'Delivery Methods' },
    { key: 'schedule', id: 'alert-form-schedule', icon: TbCalendarTime, label: 'Evaluation Schedule' },
];

export const alertFormStepsByKey = Object.fromEntries(alertFormSteps.map((step) => [step.key, step])) as Record<
    AlertFormSectionKey,
    AlertFormStep
>;
